
import Category from "../../components/category/category.component"
const Home = () =>{


  return (
    <div>
      
      <Category  />

    </div>
  );
} 

export default Home;
